/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef, useEffect } from 'react';
import { d as debounce_1 } from '../_chunks/dep-ac257584.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-37e82645.js';
import '../_chunks/dep-a0293295.js';
import '../_chunks/dep-dae4a585.js';

var DEFAULT_OPTIONS = {
  debounceTime: 0,
  config: {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  }
};
function useMutationObservable(targetEl, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
  var observeRef = useRef(null);
  useEffect(function () {
    if (!cb || typeof cb !== "function") return;
    var debounceTime = options.debounceTime;
    observeRef.current = new MutationObserver(debounceTime > 0 ? debounce_1(cb, debounceTime) : cb);
  }, [cb, options]);
  useEffect(function () {
    if (!targetEl || !(targetEl !== null && targetEl !== void 0 && targetEl.nodeType)) return;
    var config = options.config;
    try {
      observeRef.current.observe(targetEl, config);
    } catch (e) {
      console.error(e);
    }
    return function () {
      observeRef.current.disconnect();
    };
  }, [targetEl, options]);
}

export { useMutationObservable as default };
//# sourceMappingURL=useMutationObserver.js.map
